import { gql } from "@stadium/services/apollo-client";

export const MANAGE_DRAFT_AUTOMATED_CATALOG = gql`
  mutation ManageDraftAutomatedCatalog($input: ManageDraftAutomatedCatalogInput!) {
    manageDraftAutomatedCatalog(input: $input) {
      catalog {
        id
        number
        name
        kind
        createdAt
        colorGroupIds
        showDraftAutomatedMockupBanner
      }
      clientMutationId
      errors
    }
  }
`;
